module.exports = __webpack_public_path__ + "32ac0c3c8ddd64b4081ec1f406f8e3ee.jpg";